import Home from '/public/pages/Home.svelte';
import Login from '/public/pages/user/Login.svelte';
import Logout from '/public/pages/user/Logout.svelte';
import PasswordReset from '/public/pages/user/PasswordReset.svelte';
import AreaCourses from '/public/pages/areas/AreaCourses.svelte';
import AreaCourseTypeCourses from '/public/pages/areas/AreaCourseTypeCourses.svelte';
import CourseTypeCourses from '/public/pages/courses/CourseTypeCourses.svelte';
import OneCourse from '/public/pages/courses/OneCourse.svelte';
import BookOneCourse from '/public/pages/courses/BookOneCourse.svelte';
import Thanks from '/public/pages/booking/Thanks.svelte';
import Failed from '/public/pages/booking/Failed.svelte';
import CertAuth from '/public/pages/certificate/CertAuth.svelte';
import PricingAgreement from '/public/pages/orgs/PricingAgreement.svelte';
import MOU from '/public/pages/orgs/MOU.svelte';
import Director from '/public/pages/tickets/Director.svelte';

const routes = [
    {
        name: 'index',
        redirectTo: 'home'  
    },
    {
        name: '/',
        redirectTo: 'home'  
    },
    {
        name: '404',
        redirectTo: 'home'        
    },   
    {
        name: 'home',
        component: Home
    },    
    {
        name: 'login',
        component: Login
    },
    {
        name: 'logout',
        component: Logout
    },
    {
        name: 'password-reset/:hash',
        component: PasswordReset
    },
    {
        name: 'courses/:courseID',
        component: OneCourse
    },
    {
        name: 'book-course/:courseID',
        component: BookOneCourse
    },
    {
        name: 'booking/thanks',
        component: Thanks
    },
    {
        name: 'booking/failed',
        component: Failed
    },
    {
        name: 't-director/:hash',
        component: Director
    },
    {
        name: 'area/:areaID',
        nestedRoutes: [
            {
                name: 'index',
                component: Home
            },
            { 
                name: 'courses',
                component: AreaCourses
            },
            { 
                name: 'courses/:courseTypeID',
                component: AreaCourseTypeCourses
            },
            {
                name: 'organisation-pricing-agreement/:hash',
                component: PricingAgreement
            },
            {
                name: 'organisation-mou/:hash',
                component: MOU
            }
        ]        
    },
    {
        name: 'book',
        nestedRoutes: [
            {
                name: 'course/:courseTypeID',
                component: CourseTypeCourses
            }
        ]
    },
    {
        name: 'certificate/authentication/:hash',
        component: CertAuth
    },
    {
        name: 'organisation-pricing-agreement/:hash',
        component: PricingAgreement
    },
    {
        name: 'organisation-mou/:hash',
        component: MOU
    }
]

export { routes }
